// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pl-8";
export var editMode = "_pl-3";
export var headerRow = "_pl-a";
export var headerTitle = "_pl-b";
export var product = "_pl-1";
export var productDetails = "_pl-5";
export var productDivider = "_pl-7";
export var productImage = "_pl-2";
export var productInfo = "_pl-4";
export var productTitle = "_pl-6";
export var strikethrough = "_pl-9";
export var upsellProductsCard = "_pl-0";